export const SLOT_DURATION = 15; // minutes
export const SLOTS_IN_HOUR = Math.floor(60 / SLOT_DURATION); // minutes
export const SLOTS_IN_DAY = Math.floor(1440 / SLOT_DURATION); // minutes
export const PROVIDER_FRACTION = {
    60: 1,
    30: 2,
    20: 3,
    15: 4, // 4 appointments at a time
};
